module.exports = __webpack_public_path__ + "static/media/logo_civia.864380de.svg";